import { ON_BOARD_PAGES } from "Common/constant";

// Route that renders each B2B onboarding page. The stepper pages and the
// assessment all live inside /pathway-process. Onboarding (profile_status
// v2.0.0) ends with the self-assessment - there are no care standard / care
// team steps any more.
const PATHWAY_ROUTES = {
  [ON_BOARD_PAGES.language_preference]: "select-language",
  [ON_BOARD_PAGES.care_info]: "care-intro",
  [ON_BOARD_PAGES.account_confirmation]: "pathway-process",
  [ON_BOARD_PAGES.care_plan]: "pathway-process",
  [ON_BOARD_PAGES.area_of_improvement]: "pathway-process",
  [ON_BOARD_PAGES.assessment]: "pathway-process",
};

// First onboarding step the user has neither completed nor skipped, so a
// returning user resumes where they left off instead of restarting at
// language selection. Falls back to the last step if every step is marked
// done but the profile is still incomplete.
export const getResumeStep = (pathways = []) => {
  if (!Array.isArray(pathways) || !pathways.length) return null;
  return (
    pathways.find((item) => !item?.is_completed && !item?.is_skipped) ||
    pathways[pathways.length - 1]
  );
};

// Every step completed or skipped. The only thing left after the care team is
// "Proceed to Dashboard", which just flags the profile complete, so a user who
// closed the tab on that screen is treated as finished.
export const isPathwayDone = (pathways = []) =>
  Array.isArray(pathways) &&
  pathways.length > 0 &&
  pathways.every((item) => item?.is_completed || item?.is_skipped);

export const getResumeRoute = (step) =>
  PATHWAY_ROUTES[step?.page] || PATHWAY_ROUTES[ON_BOARD_PAGES.language_preference];
